import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPlayer from 'react-player';

import { useResultContext } from '../contexts/ResultContextProvider';
import { Loading } from './Loading';

export const Results = () => {
  const { results, isLoading, getResults, searchTerm } = useResultContext(); 
  const location  = useLocation();

  useEffect(() => {
    getResults(`/?query=${searchTerm}&limit=40&related_keywords=true`);
  }, [searchTerm]);

  if(isLoading) return <Loading />

  console.log(results)
  console.log(location.pathname)
  switch (location.pathname) {
    case '/search':
      return (
        <div className='flex flex-wrap justify-between space-y-6 sm:px-56'>
          {Array.isArray(results.results) ? (
            results.results.map((result, index) => (
              <div key={index} className='md:w-2/5 w-full'>
                <a href={result.url} target='_blank' rel='noreferrer'>
                  <p className='text-sm'>
                    {result.url.length > 30 ? result.url.substring(0, 30) : result.url}
                  </p>
                  <p className='text-lg hover:underline dark:text-blue-300 text-blue-700'>
                    {result.title}
                  </p>
                </a>
              </div>
            ))
          ) : (
            <p>No results found.</p>
          )}
        </div>
      );
    default:
      return 'ERROR!'
  }
}
